import { readonly, ref } from 'vue'

export type ThemePreference = 'system' | 'light' | 'dark'

// La stessa chiave è letta dallo script inline in index.html, prima del mount.
export const THEME_STORAGE_KEY = 'mobidic:theme'
const DARK_QUERY = '(prefers-color-scheme: dark)'

const isPreference = (value: unknown): value is ThemePreference =>
  value === 'system' || value === 'light' || value === 'dark'

const readStoredPreference = (): ThemePreference => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY)
    return isPreference(stored) ? stored : 'system'
  } catch {
    return 'system'
  }
}

const preference = ref<ThemePreference>(readStoredPreference())
let mediaQuery: MediaQueryList | null = null

const apply = () => {
  const systemDark = (mediaQuery ?? window.matchMedia(DARK_QUERY)).matches
  const dark = preference.value === 'dark' || (preference.value === 'system' && systemDark)
  document.documentElement.classList.toggle('dark', dark)
}

export function initTheme(): void {
  if (mediaQuery) return
  mediaQuery = window.matchMedia(DARK_QUERY)
  mediaQuery.addEventListener('change', () => {
    if (preference.value === 'system') apply()
  })
  apply()
}

export function useTheme() {
  const setPreference = (value: ThemePreference) => {
    preference.value = value
    try {
      localStorage.setItem(THEME_STORAGE_KEY, value)
    } catch {
      // Storage non disponibile: la scelta vale solo per la sessione.
    }
    apply()
  }

  return { preference: readonly(preference), setPreference }
}
